import { useEffect, useRef } from 'react';

export function useReveal() {
	const ref = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const el = ref.current;
		if (!el) return;
		const observer = new IntersectionObserver(
			([entry]) => { if (entry.isIntersecting) { el.classList.add('visible'); observer.disconnect(); } },
			{ threshold: 0.12 }
		);
		observer.observe(el);
		return () => observer.disconnect();
	}, []);
	return ref;
}
